<template>
  <form-group class="ma-0 pa-0">
    <analysis-csnu-card
      v-model="payload"
      :loading="loadingCsnu"
    />
    <analysis-ofac-card
      v-model="payload"
      :loading="loadingOfac"
    />
  </form-group>
</template>

<script>
import ShortlistRequest from 'Modules/contacard/shortlist/ShortlistRequest';
import ServiceMixin from '@/app/arch/mixins/ServiceMixin';
import FormGroup from '@/app/arch/components/crud/components/FormGroup.vue';
import AnalysisCsnuCard from 'Modules/contacard/analysisTable/components/cards/AnalysisCsnuCard.vue';
import AnalysisOfacCard from 'Modules/contacard/analysisTable/components/cards/AnalysisOfacCard.vue';

export default {
  name: 'AnalysisShortlistDisplay',
  components: { FormGroup, AnalysisCsnuCard, AnalysisOfacCard },
  mixins: [ServiceMixin],
  data: () => ({
    requestClass: ShortlistRequest,
    payload: {
      csnu: [],
      ofac: [],
    },
    loadingOfac: false,
    loadingCsnu: false,
    config: {
      errorMessage: 'Falha ao consultar nome do cliente em lista restritiva!',
      showSuccessSwal: false,
    },
  }),
  computed: {
    document() {
      return this.analysisTable.client.cpfCnpj;
    },
  },
  watch: {
    document: {
      immediate: true,
      handler(doc) {
        if (doc && String(doc).length >= 11) {
          this.search();
        }
      },
    },
  },
  methods: {
    search() {
      this.searchOfac();
      this.searchCsnu();
    },
    searchOfac() {
      this.handleLoadingOfac();
      this.makeOfacRequest();
    },
    handleLoadingOfac() {
      this.loadingOfac = !this.loadingOfac;
    },
    makeOfacRequest() {
      this.callService(
        this.requestClass.searchOfac(
          this.document,
        ),
        this.setOfacList,
        this.config,
      );
    },
    setOfacList(response) {
      this.handleLoadingOfac();
      if (this.hasData(response)) {
        this.payload.ofac = this.getResultList(response);
      }
    },
    getResultList(response) {
      const { similarRecords } = response.data;
      return similarRecords;
    },
    searchCsnu() {
      this.handleLoadingCsnu();
      this.makeCsnuRequest();
    },
    handleLoadingCsnu() {
      this.loadingCsnu = !this.loadingCsnu;
    },
    makeCsnuRequest() {
      this.callService(
        this.requestClass.searchCsnu(
          this.document,
        ),
        this.setCsnuList,
        this.config,
      );
    },
    setCsnuList(response) {
      this.handleLoadingCsnu();
      if (this.hasData(response)) {
        this.payload.csnu = this.getResultList(response);
      }
    },
  },
  inject: {
    analysisTable: {
      default() {
        return {
          client: {
            cpfCnpj: '',
          },
        };
      },
    },
  },
};
</script>
